import { 
    Card, 
    CardBody, 
    CardButtons, 
    CardGrid, 
    CardGridAmount, 
    CardGridItem, 
    CardHeader, 
    CardSubtitle, 
    CardTitle, 
    DetailsButton,
    InvoicePaymentStatus 
} from 'components';
import { formatDate } from 'functions';
import { useNavigation } from 'hooks';
import { InvoiceSummary } from 'types';
import styles from './InvoiceCard.module.scss';
import { AdjustmentType, AdjustmentTypeText } from 'enums';

type Props = {
    invoice: InvoiceSummary
}

export default function InvoiceCard({ invoice }: Props) {
    const { navigateToInvoice } = useNavigation();

    return (
        <Card className={styles.card}>
            <CardHeader className={styles.header}>
                <div className={styles.division}>
                    <CardTitle>
                        <span>Invoice {invoice.invoiceId}</span>
                    </CardTitle>
                    <CardSubtitle className={styles.subtitle}>
                        <span><strong>Vendor ID</strong>: &nbsp;{invoice.vendorId || 'Not Found'}</span>             
                        {invoice.invoiceDate && 
                            <span><strong>Sent</strong>: &nbsp;{formatDate(invoice.invoiceDate)}</span>
                        }
                    </CardSubtitle>
                </div>
                <div className={styles.division}>
                    <CardSubtitle className={styles.paymentStatus}>                    
                        <InvoicePaymentStatus invoice={invoice} />
                    </CardSubtitle>
                </div>
            </CardHeader>
            <CardBody>
                <CardGrid className={styles.grid}>
                    <CardGridAmount label="Invoiced" value={invoice.userVoucherDecimal} />
                    <CardGridAmount label="Adjustments" value={invoice.dotPriceAdjustment + invoice.dotQuantityAdjustment} />
                    <CardGridAmount label="Cash Discounts" value={invoice.discountPaymentAmount} />
                    <CardGridAmount label="Paid" value={invoice.invoicePaidAmount} /> 
                </CardGrid>
                <CardButtons>
                    <DetailsButton  onClick={() => navigateToInvoice(invoice.accountId, invoice.vendorId, invoice.invoiceId ?? '', invoice.voucherId)} />
                </CardButtons>
            </CardBody>
        </Card>
    )
}
